const NextImage = props => <img width="100%" height="100%" {...props} />;

export default NextImage;
